"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginHelper = void 0;
var environment_helper_1 = require("./environment.helper");
var Session_helper_1 = require("./Session.helper");
var LoginHelper = /** @class */ (function (_super) {
    __extends(LoginHelper, _super);
    function LoginHelper() {
    }
    Object.defineProperty(LoginHelper, "userLogged", {
        get: function () {
            return LoginHelper._userLogged;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    _a = LoginHelper;
    // * Read-only * //
    LoginHelper._userLogged = false;
    (function () {
        // Initialization:
        if (environment_helper_1.EnvironmentHelper.isClientSide()) {
            Session_helper_1.SessionHelper.getData("_isLogged")
                .then(function (val) {
                _a._userLogged = val;
            })
                .catch(function (e) {
                console.error("Failed to initialize _userLogged. ", e);
            });
        }
        // Subscriptions:
        // Subscribe login
        Session_helper_1.SessionHelper.subscribeSetDataInSession(function (e) {
            var detail = e.detail;
            if (detail.key === "_isLogged") {
                _a._userLogged = detail.value;
            }
        });
        // Subscribe logout
        Session_helper_1.SessionHelper.subscribeDeleteDataInSession(function (e) {
            var detail = e.detail;
            if (detail.key === "_isLogged") {
                _a._userLogged = false;
            }
        });
        // Subscribe session storage cleared
        Session_helper_1.SessionHelper.subscribeDeleteAllDataInSession(function () {
            _a._userLogged = false;
        });
    })();
    return LoginHelper;
}(null));
exports.LoginHelper = LoginHelper;
